<template lang="pug">
  .fill-quotation(v-loading="loading")
    sow-info(
      ref="sow_info"
    )
    title-bar {{ $t('上传方案 & 报价') }}
    el-row(style="margin-left: 20px")
      el-col.required(:span="4") {{ $t('方案') }}
      el-col(:span="20")
        template(v-if="isView")
          uploaded-file-display(
            :fileName="proposalData.file_name"
            :downloadUrl="proposalData.file_download_path"
            :fileNameList="proposalData.file_name_list"
            width="85px"
          )
        template(v-else)
          div(style="display: flex")
            new-upload-file(
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="uploadProposalDataSuccess"
            )
            uploaded-file-display(
              style="margin-left: 10px"
              :fileName="proposalData.file_name"
              :downloadUrl="proposalData.file_download_path"
              :fileNameList="proposalData.file_name_list"
              width="85px"
            )
    el-row(
      v-if="showApproveEmail"
      style="margin-left: 20px"
    )
      el-col.required(:span="4") {{ $t('广告物料制作审批邮件') }}
      el-col(:span="20")
        template(v-if="isView")
          uploaded-file-display(
            :fileName="approveEmail.file_name"
            :downloadUrl="approveEmail.download_url"
            :fileNameList="approveEmail.file_name_list"
            width="85px"
          )
        template(v-else)
          div(style="display: flex")
            new-upload-file(
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="uploadApproveEmailSuccess"
            )
            uploaded-file-display(
              style="margin-left: 10px"
              :fileName="approveEmail.file_name"
              :downloadUrl="approveEmail.download_url"
              :fileNameList="approveEmail.file_name_list"
              width="85px"
            )

    el-row(style="margin-left: 20px")
      el-col(:span="4").required {{ $t('报价') }}
      el-col(:span="20")
        .fill-quotation__quotation
          div
            el-button(@click="onClick") {{ btnStr }}

    el-row(style="margin-left: 20px")
      el-col(:span="20" :offset="4")
        quotation-overview(
          :data="quotationOverviewArr"
          :isInputRebase="isDemoUser"
          @changeRebase="changeRebase"
        )

    el-row(style="margin-left: 20px")
      el-col(
        :offset="4"
        :span="20"
      )
        div(v-if="!isView")
          el-button(
            style="width: 140px"
            type="primary"
            @click="onConfirm(true)"
          ) {{ $t('保存') }}
          el-button(
            style="width: 140px"
            type="primary"
            @click="onConfirm(false)"
          ) {{ $t('提交') }}
          el-button(
            style="width: 140px"
            @click="onCancel"
          ) {{ $t('取消') }}
    audit-versions(
      :id="auditVersionId"
      :businessType="businessType"
      :auditType="campaign.campaignSurvey.is_bypass === 1 ? 31 : 5"
    )

    quotation-dialog(
      v-if="quotationDetail.length > 0"
      :visible="visible"
      :data="quotationDetail"
      :viewMode="isView"
      @close="handleDialogClose"
    )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import QuotationDialog, { normalizeQuotation, formatParams } from '@/components/QuotationDialog'
import FooterButton from '@/components/FooterButton'
import ProcurementAuditView from '@/components/ProcurementAuditView'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import AuditVersions from '@/components/AuditVersions'
import QuotationOverview from '@/components/QuotationOverview'
import SowInfo from './SOWInfo'
import { pickBy, identity } from 'lodash'

const updateVendorQuotation = (params) =>
  axios.post('/management/subfinal/saveVendorPrice', format4backend(params))

const getVendorQuotation = (id, phaseViewed, phaseType) => {
  return axios.get('/management/subfinal/getVendorQuotation', {
    params: {
      sub_final_scope_vendor_id: id,
      phase_current: phaseViewed,
      phase_reality: phaseType
    }
  })
}

const saveVendorPriceCompleted = (id, approveEmail, proposalData, noApproveEmail, isTemporary, campaignId, taskId, isBypass) => {
  let params = {
    sub_final_scope_vendor_id: id,
    project_path: proposalData.file_path,
    is_approve_mail_path: noApproveEmail ? 0 : 1,
    is_temporary: isTemporary,
    task_id: taskId,
    campaign_id: campaignId
  }
  if (approveEmail.file_path) {
    params.approve_mail_path = approveEmail.file_path
  }
  params = pickBy(params, identity)
  let api = '/management/subfinal/saveVendorPriceCompleted'
  if (isBypass === 1) {
    api = '/management/bypassCampaign/saveVendorPriceCompleted'
  }
  return axios.post(api, format4backend(params))
}

const getShowApproveEmailResult = params => {
  return axios.post('/management/subfinal/getShowApproveEmailResult', format4backend(params))
}

const getApproveEmail = (vendorId) => {
  return axios.get('/management/subfinal/getApproveEmail', {
    params: {
      sub_final_scope_vendor_id: vendorId
    }
  })
}

export default {
  data () {
    return {
      quotationDetail: [],
      quotationOverviewArr: [],
      tableData: [],
      visible: false,
      contact: {},
      briefName: '',
      briefPath: '',
      briefRemark: '',
      showApproveEmail: false,
      loading: false,
      approveEmail: {
        file_name: null,
        file_download_path: null,
        file_path: null,
        file_name_list: []
      },
      noApproveEmail: false,
      proposalData: {
        file_name: null,
        file_download_path: null,
        file_path: null,
        file_name_list: []
      },
      quotationParams: null,
      rebaseTotalPrice: null,
      totalPrice: null
    }
  },
  computed: {
    subFinalScopeVendorId () {
      return this.$store.state.campaign.subFinalScopeVendorId
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    campaign () {
      return this.$store.state.campaign
    },
    taskName () {
      return this.$store.state.campaign.taskName
    },
    businessType () {
      return this.$store.state.campaign.businessType
    },
    uploadParams () {
      return {
        file_type: 14
      }
    },
    auditVersionId () {
      switch (this.businessType) {
        case 1:
        case 5:
          return this.campaignId
        case 2:
        case 6:
          return this.subFinalScopeId
        default:
          return this.subFinalScopeVendorId
      }
    },
    isDemoUser () {
      return this.$store.state.common.user.company_name === 'Mccann'
    },
    hasFilled () {
      return this.quotationOverviewArr.length !== 0
    },
    btnStr () {
      return this.isView ? this.$t('查看报价明细') : this.hasFilled ? this.$t('修改报价明细') : this.$t('填写报价明细')
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    }
  },
  mounted () {
    if (this.campaign.campaignSurvey.is_bypass !== 1) {
      this.fetchFinalScopeData()
    }
    this.getShowApproveEmailResult()
    this.fetchTableData()
    this.getApproveEmail()
  },
  methods: {
    changeRebase (rebase) {
      this.quotationOverviewArr.find(p => p.service_name_ch === this.$t('返点后总计')).total_price = this.rebaseTotalPrice * (100 - Number(rebase)) * 0.01
      this.quotationOverviewArr.find(p => p.service_name_ch === this.$t('返点')).total_price = this.totalPrice * (Number(rebase)) * 0.01
    },
    fetchFinalScopeData () {
      this.loading = true
      axios
        .get('/management/campaign/getBriefInfo', {
          params: {
            campaign_id: this.campaignId
          }
        })
        .then((res) => {
          this.briefName = res.brief_name
          this.briefPath = res.brief_download_url
          this.briefRemark = res.remark
          this.loading = false
        })
    },
    async fetchTableData () {
      try {
        const res = await getVendorQuotation(
          this.subFinalScopeVendorId,
          7,
          this.phaseType
        )
        this.quotationOverviewArr = res.price_overview
        this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
        this.quotationParams = formatParams(this.subFinalScopeVendorId, this.quotationDetail)
        this.proposalData.file_name = res.project_path.project_name
        this.proposalData.file_download_path = res.project_path.project_download_path
        this.proposalData.file_path = res.project_path.project_path
        this.approveEmail.file_name = res.project_path.approve_mail_name
        this.approveEmail.file_download_path = res.project_path.approve_mail_download_path
        if (this.$store.state.campaign.taskId == null) {
          this.$store.commit('campaign/setTaskId', res.task_id)
        }
      } catch (err) {
        throw new Error(err)
      }
    },
    onClick () {
      this.visible = true
    },
    onCancel () {
      this.$router.push('/vendor-campaign/process')
    },
    handleDialogClose (res, params) {
      this.visible = false
      if (res) {
        if (this.isDemoUser) {
          res.price_overview.find(p => p.service_name_ch === this.$t('返点后总计')).total_price = res.price_overview.find(p => p.service_name_ch === this.$t('合计')).total_price
          res.price_overview.find(p => p.service_name_ch === this.$t('返点')).total_price = 0
          res.price_overview.splice(res.price_overview.length - 1, {
            category_name: 'Rebate',
            category_name_ch: '返点',
            service_name: 'Rebate',
            service_name_ch: '返点'
          })
          this.rebaseTotalPrice = res.price_overview.find(p => p.service_name_ch === this.$t('返点后总计')).total_price
          this.totalPrice = res.price_overview.find(p => p.service_name_ch === this.$t('合计')).total_price
        }
        this.quotationOverviewArr = res.price_overview
        this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
        this.quotationParams = params
      }
    },
    async onConfirm (isSave) {
      if (!isSave && this.showApproveEmail && !this.noApproveEmail && !this.approveEmail.file_path) {
        this.$message.error(this.$t('请上传广告物料制作审批邮件'))
        return
      }

      if (!this.checkQuotation()) {
        this.$message.error(this.$t('请填写报价'))
        return
      }

      if (!isSave && !this.proposalData.file_path) {
        this.$message.error(this.$t('请上传方案'))
        return
      }

      this.loading = true
      const params = this.quotationParams
      try {
        let quotationFileTemporary = isSave ? 1 : 0
        let msg = isSave ? this.$t('保存成功') : this.$t('提交成功')
        params.is_temporary = isSave ? 1 : 0
        params.business_type = this.businessType
        if (isSave && !this.proposalData.file_path) {
          await updateVendorQuotation(params)
        } else {
          await Promise.all([
            updateVendorQuotation(params),
            saveVendorPriceCompleted(
              this.subFinalScopeVendorId,
              this.approveEmail,
              this.proposalData,
              this.noApproveEmail,
              quotationFileTemporary,
              this.$store.state.campaign.id,
              this.$store.state.campaign.taskId,
              this.campaign.campaignSurvey.is_bypass
            )])
        }
        this.$refs.sow_info.getSOWInfo()
        this.$message.success(this.$t(msg))
      } catch (err) {
        throw new Error(err)
      } finally {
        this.loading = false
        if (!isSave) {
          this.$router.push('/vendor-campaign/process')
        }
      }
    },
    async getShowApproveEmailResult () {
      try {
        const params = {
          sub_final_scope_id: this.subFinalScopeId
        }
        const res = await getShowApproveEmailResult(params)
        this.showApproveEmail = res.show_approve_email
      } catch (err) {
        throw new Error(err)
      }
    },
    async getApproveEmail () {
      try {
        this.approveEmail = await getApproveEmail(this.subFinalScopeVendorId)
      } catch (err) {
        throw new Error(err)
      }
    },
    uploadProposalDataSuccess (res) {
      this.proposalData = res
    },
    uploadApproveEmailSuccess (res) {
      this.approveEmail = res
    },
    // hack: 检查是否有报价数据
    checkQuotation () {
      return document.querySelector('.quotation-overview .el-table') != null
    }
  },
  components: {
    TitleBar,
    QuotationDialog,
    FooterButton,
    ProcurementAuditView,
    NewUploadFile,
    UploadedFileDisplay,
    AuditVersions,
    SowInfo,
    QuotationOverview
  }
}
</script>

<style lang="stylus">
.fill-quotation__quotation
  display flex
  > div:nth-child(1)
    margin-right 10px
</style>
